export default class Component {
    constructor(props) {
    }

    init() {

    }
}